import { render, staticRenderFns } from "./MultiselectAvatarWithBookmark.vue?vue&type=template&id=3936f931&scoped=true"
import script from "./MultiselectAvatarWithBookmark.vue?vue&type=script&lang=ts"
export * from "./MultiselectAvatarWithBookmark.vue?vue&type=script&lang=ts"
import style0 from "./MultiselectAvatarWithBookmark.vue?vue&type=style&index=0&id=3936f931&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3936f931",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3936f931')) {
      api.createRecord('3936f931', component.options)
    } else {
      api.reload('3936f931', component.options)
    }
    module.hot.accept("./MultiselectAvatarWithBookmark.vue?vue&type=template&id=3936f931&scoped=true", function () {
      api.rerender('3936f931', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/MultiselectAvatarWithBookmark.vue"
export default component.exports